import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type UserDataFragment = { id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null };


export type UserDataFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserDataFragmentDoc = /*#__PURE__*/ gql`
    fragment UserData on UserProfile {
  id
  name
  uniqueId
  emailId
  profilePicture
}
    `;